// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class UserEmailDefault {
  readonly defaultCc: string[];
  readonly defaultBcc: string[];

  constructor(data: { [key: string]: any } = {}) {
    this.defaultCc = data.defaultCc ?? [];
    this.defaultBcc = data.defaultBcc ?? [];
  }

  static zero(): UserEmailDefault {
    const zeroValues: ExcludeMethodsDeep<UserEmailDefault> = {
      defaultCc: [],
      defaultBcc: [],
    };
    return new UserEmailDefault(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type UserEmailDefaultWireFormat = {
  defaultCc: string[];
  defaultBcc: string[];
};

type NewUserEmailDefaultProps = PartialDeep<UserEmailDefault, { recurseIntoArrays: true }>;
export const NewUserEmailDefault: (props: NewUserEmailDefaultProps) => UserEmailDefault = (props) =>
  new UserEmailDefault(props);

type NewUserEmailDefaultFromWireFormatProps = PartialDeep<
  UserEmailDefaultWireFormat,
  { recurseIntoArrays: true }
>;
export const NewUserEmailDefaultFromWireFormat: (
  props: NewUserEmailDefaultFromWireFormatProps,
) => UserEmailDefault = (props) => new UserEmailDefault(props);
